import { gql } from "@apollo/client";

export const FIND_COMMUNICATION_PLAN_BY_PLAN = gql`
  query findCommunicationPlanByPlan($uuid: ID!) {
    findCommunicationPlanByPlan(uuid: $uuid) {
      communicationPlanInPlace
      email
      lastUpdate
      planOwnerFirstName
      planOwnerLastName
      uuid
    }
  }
`;

export const UPDATE_COMMUNICATION_PLAN = gql`
  mutation UpdateCommunicationPlan($data: UpdateCommunicationPlanInput!) {
    updateCommunicationPlan(data: $data) {
      communicationPlanInPlace
      email
      lastUpdate
      planOwnerFirstName
      planOwnerLastName
      uuid
    }
  }
`;